import Request from '../Request/Request';

export default function getData( apiCall, setData, callback ) { 
    Request.get( apiCall, 
		result => { 
			if ( setData ) {
				setData( result.data ) 
			}
			if ( typeof callback !== 'undefined' && callback !== null ) {
				callback( result.data )
			}
		},
		error => {
			if ( setData ) {
				setData( [] ) 
			}
			if ( typeof callback !== 'undefined' && callback !== null ) {
				callback( [] )
			}			
		}
    )
}
